export const apiUrl = process.env.REACT_APP_API_BASE_URL;

let unauthorizedHandler = null;

// Регистрирует коллбэк сброса сессии при 401 (вызывается из index.js)
export function setUnauthorizedHandler(fn) {
    unauthorizedHandler = fn;
}

function value4query(key, value) {
    if (value === null || value === undefined) {
        return '';
    }
    return value;
}

// Ссылка на эндпоинт API с sessionId в query (для <img>/<a>, не отправляющих заголовки)
export function apiLink(path) {
    return `${apiUrl}/api/${path}${path.includes('?') ? '&' : '?'}sessionId=${localStorage.getItem('sessionId')}`;
}

export function fileUrl(id, inline) {
    return apiLink(`file/${id}${inline ? '?inline=true' : ''}`);
}

export async function serverFetch(address, options) {
    const sessionId = localStorage.getItem('sessionId');
    options = options || {};
    let url = new URL(`${apiUrl}/api/${address}`);
    Object.keys(options.queryParams || {}).forEach((key) => {
        if (Array.isArray(options.queryParams[key])) {
            options.queryParams[key].forEach((value) => url.searchParams.append(key, value4query(key, value)));
        } else {
            url.searchParams.append(key, value4query(key, options.queryParams[key]));
        }
    });

    const headers = new Headers({ accept: 'application/json' });
    if (!options.formData) {
        headers.append('Content-Type', 'application/json');
    }
    let init = {
        method: 'GET',
        ...options,
        headers,
    };

    if (sessionId) {
        init.headers.append('SessionId', sessionId);
    }

    if (options.formData != null) {
        init.body = options.formData;
    } else if (options.bodyData != null) {
        init.body = JSON.stringify(options.bodyData);
    }

    let response;
    try {
        response = await fetch(url, init);
    } catch (exc) {
        throw new Error('Ошибка соединения с сервером');
    }

    if (response.ok && response.status === 204) {
        return;
    }

    let responseContentPromise;
    if (!response.ok || options.rawResponse) {
        responseContentPromise = response.text();
    } else if (options.download || options.blob) {
        responseContentPromise = response.blob();
    } else if ((response.headers.get('content-type') || '').includes('text/')) {
        responseContentPromise = response.text();
    } else {
        responseContentPromise = response.json();
    }

    let content;
    try {
        content = await responseContentPromise;
    } catch (exc) {
        throw new Error('Error parsing response body');
    }

    if (response.ok) {
        return content;
    }

    if (response.status === 401 && unauthorizedHandler) {
        unauthorizedHandler();
    }

    if (!content) {
        content = {
            statusCode: response.status,
            userMessage: response.statusText,
        };
    } else if (typeof content === 'string') {
        try {
            content = JSON.parse(content);
        } catch (e) {
            content = { statusCode: response.status, userMessage: content };
        }
    }
    throw content;
}
